module.exports = __webpack_public_path__ + "static/media/frontPage.a0bfafa3.png";